import type { GalleryImage } from "@mobility-item-page/dealer";
import { type RefObject, useRef } from "react";

export const distanceToCurrentImage = (currentImageIndex: number, index: number, length: number) => {
  const distance1 = Math.abs(currentImageIndex - index);
  const distance2 = Math.abs(currentImageIndex + length - index);

  return Math.min(distance1, distance2);
};

export const generateSrcSet = (image?: string) => {
  if (image) {
    const sizes = ["1600w", "1280w", "960w", "640w", "320w", "142w"];
    return sizes.map((size) => `${image.replaceAll("default", size)} ${size}`).join(",");
  }
  return undefined;
};

export const getVisibleImageIndex = (listRef: RefObject<HTMLUListElement | null>, images: GalleryImage[]) => {
  const list = listRef.current;
  if (!list || images.length === 0) return -1;

  const scrollLeft = list.scrollLeft;
  let closestIndex = -1;
  let closestDiff = Number.POSITIVE_INFINITY;

  const childCount = list.children.length;
  for (let i = 0; i < childCount; i++) {
    const li = list.children.item(i) as HTMLLIElement | null;
    if (!li) continue;
    const diff = Math.abs(li.offsetLeft - scrollLeft);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestIndex = i;
    }
  }

  return closestIndex;
};

export const useDebounce = () => {
  const ref = useRef<NodeJS.Timeout | null>(null);

  return (callback: () => void, delay: number, cleanup?: () => void) => {
    if (ref.current) clearTimeout(ref.current);
    ref.current = setTimeout(callback, delay);
    return () => {
      if (ref.current) clearTimeout(ref.current);
      cleanup?.();
    };
  };
};
